// extracted by mini-css-extract-plugin
export default {"body":"MembershipCard_body__OuOhC","unionLogo":"MembershipCard_unionLogo__rnx+0"};